import { Alert } from 'react-bootstrap'
import React from 'react'

export interface VerificationErrorAlertProps {
  clientSideVerificationError: string | null
  serverSideVerificationErrors: string[]
  hasClientOrServerVerificationError: boolean
  usersCount: number
}

export const VerificationErrorAlert = ({
  clientSideVerificationError,
  serverSideVerificationErrors,
  hasClientOrServerVerificationError,
  usersCount,
}: VerificationErrorAlertProps) => {
  return (
    <>
      {clientSideVerificationError ? (
        <Alert variant='warning' className='mt-4'>
          {clientSideVerificationError}
        </Alert>
      ) : null}
      {hasClientOrServerVerificationError && usersCount > 0 ? (
        <Alert variant='warning' className='mt-4'>
          The uploaded CSV has verification error(s), please check them below
          {serverSideVerificationErrors.length ? (
            <ul>
              {serverSideVerificationErrors.map((error) => (
                <li key={error}>{error}</li>
              ))}
            </ul>
          ) : null}
        </Alert>
      ) : null}
    </>
  )
}
